module.exports = __webpack_public_path__ + "static/img/img-36.dd2307a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/backgrounds/img-36.jpg
// module id = CUta
// module chunks = 0